"use client";

import { useEffect } from "react";
import { captureException } from "@/lib/sentry";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <html lang="de" className="dark">
      <body className="antialiased min-h-screen flex items-center justify-center p-6"
        style={{ backgroundColor: "#0A0A0A", color: "#ffffff" }}>
        <div className="max-w-md text-center space-y-6">
          <div style={{ color: "#70D993", fontSize: "0.75rem", fontFamily: "monospace", textTransform: "uppercase", letterSpacing: "0.1em" }}>
            SYSTEM ERROR
          </div>
          <h1 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            Ein unerwarteter Fehler ist aufgetreten
          </h1>
          <p style={{ color: "#9ca3af", fontSize: "0.875rem" }}>
            Wir wurden automatisch benachrichtigt und arbeiten an einer Lösung.
          </p>
          <button
            onClick={reset}
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: "#70D993",
              color: "#000000",
              fontWeight: "bold",
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              border: "none",
              cursor: "pointer",
            }}
          >
            ERNEUT VERSUCHEN
          </button>
        </div>
      </body>
    </html>
  );
}
